// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

export { useIsNav4Enabled } from './useIsNav4Enabled';
export { getIsNav4Enabled } from './getIsNav4Enabled';
export { useNav4OptOut } from './useNav4OptOut';
export { useAddUFOCustomDataForNavType } from './useAddUFOCustomDataForNavType';
export { useUpdateNav4OptIn } from './useUpdateNav4OptIn';
export { useGetNav4OptIn } from './useGetNav4OptIn';
export { getNav4GAPhase } from './getNav4GAPhase';

export const NAV_4_MAIN_CONTENT_ID = 'AkMainContent';
